import './Financial.css';
import { iconsImgs } from '../../utils/images';
const Financial = () => {
  return (
    <div className='subgrid-two-item grid-common grid-c8'>
        <div className="grid-c-title">
            <h3 className='grid-c-title-text'>
                Financial Advice
            </h3>
            <button className='grid-c-tilte-icon'>
                <img src={iconsImgs.plus} />
            </button>
        </div>
        <div className="grid-c8-content">
            <p className='text text-silver-v1'>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit....
            </p>
        </div>
    </div>
  )
}

export default Financial